import { Range } from "immutable";

import { createAPI, updateAPI, getAPI, getAllAPI, deleteAPI } from "./api";
import { handleError, apiRequest } from "../lib/utils/request";
import { ValidationError } from "../../common/lib/validation";
import { setField } from "../../common/lib/redux-fields/actions";

export const GET_ADMINS = "GET_ADMINS";
export const GET_ADMINS_SUCCESS = "GET_ADMINS_SUCCESS";
export const GET_ADMINS_ERROR = "GET_ADMINS_ERROR";
export const GET_ADMINS_FINALLY = "GET_ADMINS_FINALLY";

export const GET_ADMIN = "GET_ADMIN";
export const GET_ADMIN_SUCCESS = "GET_ADMIN_SUCCESS";
export const GET_ADMIN_ERROR = "GET_ADMIN_ERROR";
export const GET_ADMIN_FINALLY = "GET_ADMIN_FINALLY";

export const CREATE_ADMIN = "CREATE_ADMIN";
export const CREATE_ADMIN_SUCCESS = "CREATE_ADMIN_SUCCESS";
export const CREATE_ADMIN_ERROR = "CREATE_ADMIN_ERROR";
export const CREATE_ADMIN_FINALLY = "CREATE_ADMIN_FINALLY";

export const UPDATE_ADMIN = "UPDATE_ADMIN";
export const UPDATE_ADMIN_SUCCESS = "UPDATE_ADMIN_SUCCESS";
export const UPDATE_ADMIN_ERROR = "UPDATE_ADMIN_ERROR";
export const UPDATE_ADMIN_FINALLY = "UPDATE_ADMIN_FINALLY";

export const DELETE_ADMIN = "DELETE_ADMIN";
export const DELETE_ADMIN_SUCCESS = "DELETE_ADMIN_SUCCESS";
export const DELETE_ADMIN_ERROR = "DELETE_ADMIN_ERROR";
export const DELETE_ADMIN_FINALLY = "DELETE_ADMIN_FINALLY";

export const SET_ADMIN_PAGE = "SET_ADMIN_PAGE";
export const SET_ADMIN_SORT = "SET_ADMIN_SORT";

export const ADMIN_CLEAR_ERROR = "ADMIN_CLEAR_ERROR";
export const ADMIN_CLEAR_FORM = "ADMIN_CLEAR_FORM";

export const SET_DELETE_STATUS = "SET_DELETE_STATUS";

const validateCreate = (validate, msg, fields) =>
  validate(fields)
    .prop("email")
    .required(msg["app.validation.required"])
    .prop("password")
    .required(msg["app.validation.required"])
    .getErrors();

export const getAll = () => async (dispatch, getState, utils) => {
  const data = getState().admin.meta.toJS();

  const action = GET_ADMINS;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAllAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const get = data => async (dispatch, getState, utils) => {
  const action = GET_ADMIN;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      getAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const create = data => async (dispatch, getState, utils) => {
  const action = CREATE_ADMIN;
  try {
    return await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      createAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const update = data => async (dispatch, getState, utils) => {
  const action = UPDATE_ADMIN;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateCreate,
      updateAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const updateProfile = data => async (dispatch, getState, utils) => {
  const action = UPDATE_ADMIN;
  try {
    const validateProfile = () => {
      if (data.password !== data.confirmPassword) {
        return new ValidationError("changePassword", "Hasła nie są takie same");
      }
    };
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      validateProfile,
      updateAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );
    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const deleteOne = data => async (dispatch, getState, utils) => {
  const action = DELETE_ADMIN;
  try {
    const rs = await apiRequest(
      dispatch,
      getState,
      utils,
      action,
      null,
      deleteAPI,
      data,
      { authorized: true },
      body => {
        return new ValidationError("all", "");
      }
    );

    return rs;
  } catch (error) {
    handleError(dispatch, getState, action, error);
  }
};

export const setPage = page => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_ADMIN_PAGE,
    payload: { page }
  });

  dispatch(getAll());
};

export const setSort = (field, dir) => async (dispatch, getState, utils) => {
  dispatch({
    type: SET_ADMIN_PAGE,
    payload: { page: 1 }
  });

  dispatch({
    type: SET_ADMIN_SORT,
    payload: { field, dir }
  });

  dispatch(getAll());
};

export const clearError = field => ({
  type: ADMIN_CLEAR_ERROR,
  payload: { field }
});

export const clearForm = () => ({
  type: ADMIN_CLEAR_FORM
});

export const setDeleteStatus = status => ({
  type: SET_DELETE_STATUS,
  payload: { status }
});



// WEBPACK FOOTER //
// ./src/common/admin/actions.js